"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var P = _interopRequireWildcard(require("@react-pdf/primitives"));

var isTextInstance = R.propEq('type', P.TextInstance);
var _default = isTextInstance;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@react-pdf/render/lib/utils/isTextInstance.js
// module id = 486
// module chunks = 0